import React from 'react';
import { quickLinks } from '../data/mockData';

function QuickLinks() {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h2 className="text-xl font-semibold text-green-800 mb-4">สิ่งที่ใช้บ่อย</h2>
      <div className="space-y-2">
        {quickLinks.map((link) => (
          <a
            key={link.id}
            href={link.url}
            className="flex items-center space-x-2 text-gray-700 hover:text-green-800 hover:bg-green-50 p-2 rounded-md"
          >
            <span>›</span>
            <span>{link.title}</span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default QuickLinks; 